import script from "./BlogFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogFooter.vue?vue&type=script&setup=true&lang=ts"

import "./BlogFooter.vue?vue&type=style&index=0&id=053c353a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053c353a"]])

export default __exports__